import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {PasswordResetComponent} from '../auth/password-reset/password-reset.component';
import {PasswordResetConfirmationComponent} from '../auth/password-reset-confirmation/password-reset-confirmation.component';
import {PasswordSetComponent} from '../auth/password-set/password-set.component';
import {PasswordSetConfirmationComponent} from '../auth/password-set-confirmation/password-set-confirmation.component';
import {AccountConfirmationComponent} from '../../user/account/components/account-confirmation/account-confirmation.component';
import {BlankLayoutComponent} from '../../layouts/blank-layout/blank-layout.component';
import {CookieConsentModule} from '../cookie-consent/cookie-consent.module';

const routes: Routes = [
    {
        path: '',
        component: BlankLayoutComponent,
        children: [
            {path: 'password/reset', component: PasswordResetComponent, pathMatch: 'full'},
            {path: 'password/reset/confirmation', component: PasswordResetConfirmationComponent, pathMatch: 'full'},
            {path: 'password/set/:Id', component: PasswordSetComponent, pathMatch: 'full'},
            {path: 'password/confirmation', component: PasswordSetConfirmationComponent, pathMatch: 'full'},
            {path: 'account/confirmation', component: AccountConfirmationComponent, pathMatch: 'full'},
        ]
    }
];

@NgModule({
    declarations: [
        BlankLayoutComponent
    ],
    imports: [
        CommonModule,
        [RouterModule.forChild(routes)],
        CookieConsentModule,
    ],
    exports: [
        [RouterModule]
    ]
})
export class BlankLayoutModule {
}
